import { createSlice } from "@reduxjs/toolkit";
const initialAuthState = {
  approvalData: {
    applicationNum: "",
    customerName: "",
    mandateNumber: "",
    umrnNumber: "",
    deactivationDate: null,
    deactivationReason: "",
  },
  showOrHideComponents: {
    showOrHideDetail: false,
  },
  mandateDetails: {
    nachSponserBank: "",
    ifsc: "",
    micr: "",
    draweeBank: "",
    branchName: "",
    accountNumber: "",
    accountHolderName: "",
    nachAmt: "",
    mandateAmt: "",
    frequency: "",
    fileFBD: null,
    mandateStartDate: null,
    firstNachBillingDate: null,
    mandateValidity: "",
    mandateEndDate: null,
    debitType: "",
    mobileNumber: "",
    email: "",
    status: "",
  },
  editLock: {
    editLockFlag: "",
    branch: "",
    applicationNumber: "",
  },
  initialDeActivationDateReason: {
    date: "",
    reason: "",
  },
  updateDeActivationDateReason: {
    date: "",
    reason: "",
  },
};
const NachApprovalReducer = createSlice({
  name: "activateDeactivateModal",
  initialState: initialAuthState,
  reducers: {
    updateValues(state, action) {
      state.approvalData.applicationNum = action.payload.applicationNum;
      state.approvalData.customerName = action.payload.applicationCustomer;
      state.approvalData.mandateNumber = action.payload.mandateNum;
      state.approvalData.umrnNumber = action.payload.umrnNumber;
      // state.approvalData.mandateBank =
      //   action.payload.nachBankVoList[0].bankName;
    },

    //Reducer method for storing and hiding the components
    updateShowOrHideDetail(state, action) {
      state.showOrHideComponents.showOrHideDetail = action.payload;
    },
    updateMandateDetails(state, action) {
      state.mandateDetails.nachSponserBank = action.payload.sponsorBank;
      state.mandateDetails.ifsc = action.payload.nachBankVoList[0].ifscCode;
      state.mandateDetails.micr = action.payload.nachBankVoList[0].micr;
      state.mandateDetails.draweeBank =
        action.payload.nachBankVoList[0].bankName;
      state.mandateDetails.branchName =
        action.payload.nachBankVoList[0].branchName;
      state.mandateDetails.accountNumber =
        action.payload.nachBankVoList[0].bankAccountNum;
      state.mandateDetails.accountHolderName =
        action.payload.nachBankVoList[0].bankAccHolderName;
      state.mandateDetails.nachAmt = action.payload.nachAmt;
      state.mandateDetails.mandateAmt = action.payload.mandateAmt;
      state.mandateDetails.frequency = action.payload.frequency;
      state.mandateDetails.fileFBD = action.payload.fbd;
      state.mandateDetails.mandateStartDate = action.payload.mandateStartDate;
      state.mandateDetails.firstNachBillingDate =
        action.payload.firstNachBillingDate;
      state.mandateDetails.mandateValidity = action.payload.mandateValidity;
      state.mandateDetails.mandateEndDate = action.payload.mandateEndDate;
      state.mandateDetails.debitType = action.payload.debitType;
      state.mandateDetails.status = action.payload.status;
      state.mandateDetails.mobileNumber = action.payload.customerMobileNum;
      state.mandateDetails.email = action.payload.customerEmailId;
    },
    updateDeactivationReason(state, action) {
      state.approvalData.deactivationReason = action.payload;
      state.updateDeActivationDateReason.reason = action.payload;
    },
    updateDeactivationDate(state, action) {
      state.approvalData.deactivationDate = action.payload;
      state.updateDeActivationDateReason.date = action.payload;
    },
    resetValues(state, action) {
      state.approvalData.applicationNum = "";
      state.approvalData.customerName = "";
      state.approvalData.mandateNumber = "";
      state.approvalData.umrnNumber = "";
      state.approvalData.deactivationDate = null;
      state.approvalData.deactivationReason = "";
      state.showOrHideComponents.showOrHideDetail = false;
    },
    //Edit lock updation
    updateEditLockFlag(state, action) {
      state.editLock.editLockFlag = action.payload;
    },
    updateEditLockBranch(state, action) {
      state.editLock.branch = action.payload;
    },
    updateEditLockApplicationNumber(state, action) {
      state.editLock.applicationNumber = action.payload;
    },
    updateInitialDeactivationDateReason(state, action) {
      state.initialDeActivationDateReason.date =
        action.payload.deActivationDate;
      state.initialDeActivationDateReason.reason = action.payload.remarks;
    },
  },
});
export const NachApprovalReducerAction = NachApprovalReducer.actions;
export default NachApprovalReducer.reducer;
